import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

const reviewStatus = {
  pastReviewDueDate: {
    indicatorClassName: 'tw-bg-red-500',
    textClassName: 'tw-text-red-500',
  },
  beforeReminderDate: {
    indicatorClassName: 'tw-bg-green-400',
    textClassName: 'tw-text-green-400',
  },
  pastReminderDate: {
    indicatorClassName: 'tw-bg-amber-400',
    textClassName: 'tw-text-amber-600',
  },
};

export default function ReviewStatusIndicator({ dueDate, status }) {
  const displayableStatus = reviewStatus[status];

  return displayableStatus ?
      <div className='tw-flex tw-min-w-0 tw-items-center'>
        <div
          className={classNames(
            'tw-inline-flex tw-h-2.5 tw-w-2.5 tw-flex-none tw-rounded-full',
            displayableStatus.indicatorClassName,
          )}
        />
        <div
          className={classNames(
            'tw-ml-1 tw-truncate tw-text-s tw-font-medium tw-tracking-wide',
            displayableStatus.textClassName,
          )}
        >
          {dueDate}
        </div>
      </div>
    : null;
}

ReviewStatusIndicator.propTypes = {
  dueDate: PropTypes.string,
  status: PropTypes.oneOf(Object.keys(reviewStatus)),
};
